module.exports = __webpack_public_path__ + "img/map.1426558d.svg";